export default __webpack_public_path__ + "static/media/tab-icon-2-sm.a5764c0b.svg";